import { render, staticRenderFns } from "./cyxy.vue?vue&type=template&id=38d8f9bc&scoped=true&"
import script from "./cyxy.vue?vue&type=script&lang=js&"
export * from "./cyxy.vue?vue&type=script&lang=js&"
import style0 from "./cyxy.vue?vue&type=style&index=0&id=38d8f9bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d8f9bc",
  null
  
)

export default component.exports